<dacks-layout>
  <myupdates-app-header slot="header"></myupdates-app-header>
  @if (isNotProductChangeSelectionView$ | async) {
    <myupdates-app-local-nav slot="local-nav"></myupdates-app-local-nav>
  }

  <!-- TODO sobald beim DACKS Layout auch Hintergrundfarben konfiguriert werden können, darauf umstellen -->
  <!-- Workaround, da das dacks-layout eine Konfiguration der Hintergrundfarbe noch nicht anbietet -->
  <!--    (background-color vom dacks-layout kann ab Version 0.15 nicht mehr gesetzt werden)  -->
  <!--    (background-color vom dacks-content reicht nicht aus, da die dacks-local-nav wegen ihrer Animation auch die Hintergrundfarbe benötigt)  -->
  @if (isHomeRoute$ | async) {
    <div class="bg-gradient-blue-to-left h-[31rem] w-full absolute hidden md:block"></div>
  }

  <router-outlet></router-outlet>

  <!-- TODO sobald das DACKS Layout auch einen Slot für footer anbietet, diesen setzen -->
  <!-- Aktuell Workaround mit dem z-index, damit der Footer ab dem Breakpoint lg über der Right Aside liegt -->
  <!-- In der Version 0.16.0 von DaCKS hat die Right Aside einen z-index von 400 -->
  <div class="relative mt-auto">
    <footer class="sm:absolute inset-x-0 bottom-0 lg:z-[500] bg-coldgray-50 lg:border-t border-coldgray-150 sm:h-[4.375rem] md:h-[4.875rem] xl:h-[5.375rem] flex items-center sm:justify-end">
      <myupdates-footer></myupdates-footer>
    </footer>
  </div>

  <dackl-alert class="fixed inset-x-4 lg:inset-x-6 z-index-topmost space-y-2 max-w-max sm:w-96 ml-auto top-14 sm:top-15">
  </dackl-alert>
</dacks-layout>

@if (appState.isPersonalized$ | async) {
  <mydatev-agreements></mydatev-agreements>
}
